import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FactsheetApiService } from './factsheet-api.service';
import { FactsheetEffects } from './factsheet.effects';
import { factsheetReducer, factsheetInitialState } from './factsheet.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('factsheet', factsheetReducer, {
      initialState: factsheetInitialState
    }),
    EffectsModule.forFeature([FactsheetEffects])
  ],
  providers: [FactsheetApiService]
})
export class FactsheetStoreModule {}
